function User(data) {

    var self = this;

    if (typeof data === "undefined" || data === null) {
        return null;
    }

    // Public Variables
    self.id = data.id;
    self.dateCreated = data.dateCreated;

    self.timeZone = (typeof data.timeZone === "undefined" || data.timeZone === -1) ? new Date().getTimezoneOffset() * -1 : data.timeZone;
    self.timeZoneId = data.timeZoneId;
    self.dateFormat = data.dateFormat;
    self.timeFormat = data.timeFormat;

    self.emailConfirm = "";
    self.passwordHash = "";
    self.confirmPasswordHash = "";
    self.oldPasswordHash = "";

    self.loggedIn = data.loggedIn;

    // Observables
    self.firstName = ko.observable(data.firstName);
    self.lastName = ko.observable(data.lastName);
    self.displayName = ko.observable(data.displayName);
    self.email = ko.observable(data.emailAddress);
    self.isNewsletterActive = ko.observable(data.isNewsletterActive);

    self.phoneNumber1 = ko.observable("");
    self.phoneNumber2 = ko.observable("");
    self.twoFactorAuthEnabled = ko.observable(false);
    self.twoFactorAuthCode = ko.observable("");
    self.twoFactorAuthCodeGuid = ko.observable("");

    //Computeds
    self.fullName = ko.computed(function() {
        return (self.firstName() && self.lastName()) ? self.firstName() + " " + self.lastName() : "";
    });

    self.hasMatchingNames = ko.computed(function() {
        return (typeof self.email() != "undefined" && self.email().toLowerCase() === self.displayName().toLowerCase());
    });

    self.momentDateFormat = ko.computed(function() {
        var dateFormat = self.dateFormat ? cccApp.dates.convertCDateFormatToMomentFormat(self.dateFormat) : "DD MMM";
        return dateFormat;
    });

    self.momentTimeFormat = ko.computed(function() {
        var timeFormat = self.timeFormat ? cccApp.dates.convertCTimeFormatToMomentFormat(self.timeFormat) : "hh:mma";
        return timeFormat;
    });

    self.momentDateTimeFormat = ko.computed(function() {
        var dateFormat = self.dateFormat ? cccApp.dates.convertCDateFormatToMomentFormat(self.dateFormat) : "DD MMM";
        var timeFormat = self.timeFormat ? cccApp.dates.convertCTimeFormatToMomentFormat(self.timeFormat) : "hh:mma";

        return dateFormat + " " + timeFormat;
    });

    self.hasMatchingFullName = function() {
        return (self.fullName() && self.fullName().toLowerCase() === self.displayName().toLowerCase());
    };

    return self;
}